var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoOsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.38 20.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb962d;}.cls-2{fill:#5ab455;}.cls-3{fill:#c8194b;}.cls-4{fill:#7d82b4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.65,
    cy: 4.65,
    r: 4.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,16.15v4.23H4.22a5.07,5.07,0,0,0,5.07-5.07V11.09H5.07A5.06,5.06,0,0,0,0,16.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.09,5.07V9.29h4.22a5.07,5.07,0,0,0,5.07-5.07V0H16.15A5.06,5.06,0,0,0,11.09,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.73,11.09a4.65,4.65,0,1,0,4.65,4.64A4.64,4.64,0,0,0,15.73,11.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOsa);
export default __webpack_public_path__ + "static/media/ico-osa.f166e7dbb2ec2ce4e3c945983c1945b0.svg";
export { ForwardRef as ReactComponent };